import { useSupplierByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { useCallback, useState } from 'react';

export const useBankInformation = () => {
  const [modalState, setModalState] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data = {} } = useSupplierByIdQuery({ id });
  const onModalStateChange = useCallback(() => setModalState((prevState) => !prevState), []);
  return {
    modalState,
    bank: data.bankInformation || {},
    onModalStateChange,
  };
};
